const routes = [{
  path: '/',
  name: 'index',
  component: resolve => require(['../views/index'], resolve)
}, {
  path: '/login',
  name: 'login',
  component: resolve => require(['../views/login/index'], resolve)
}, {
  path: '/register',
  name: 'register',
  component: resolve => require(['../views/register/index'], resolve)
}, {
  path: '/forgetAccount',
  name: 'forgetAccount',
  component: resolve => require(['../views/forget/forgetAccount'], resolve)
}, {
  path: '/forgetPassword',
  name: 'forgetPassword',
  component: resolve => require(['../views/forget/forgetPassword'], resolve)
}, {
  path: '/searchPage',
  name: 'searchPage',
  component: resolve => require(['../views/searchPage/index'], resolve)
}, {
  path: '/shopline',
  name: 'shopline',
  component: resolve => require(['../views/shopline/index'], resolve)
}, {
  path: '/shoplineDetails',
  name: 'shoplineDetails',
  component: resolve => require(['../views/shopline/shoplineDetails'], resolve)
}, {
  path: '/shoppingCart',
  name: 'shoppingCart',
  component: resolve => require(['../views/shopline/shoppingCart'], resolve)
}, {
  path: '/myOrder',
  name: 'myOrder',
  component: resolve => require(['../views/shopline/myOrder'], resolve)
}, {
  path: '/cuttingEdgeNews',
  name: 'cuttingEdgeNews',
  component: resolve => require(['../views/cuttingEdgeNews/index'], resolve)
}, {
  path: '/cuttingEdgeNewsDetails',
  name: 'cuttingEdgeNewsDetails',
  component: resolve => require(['../views/cuttingEdgeNews/details'], resolve)
}, {
  path: '/tastingRoom',
  name: 'tastingRoom',
  component: resolve => require(['../views/tastingRoom/index'], resolve)
}, {
  path: '/about',
  name: 'about',
  component: resolve => require(['../views/about/index'], resolve)
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/router.js